import { LoadingSpinner } from "@/modules/ui/components/loading"
import { BoxStaffInvitation } from "@modules/boxStaff/components/boxStaffInvitation"
import { BoxStaffInvitationErrorView } from "@modules/boxStaff/components/boxStaffInvitationErrorView"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { type SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { LocalStorageKeys } from "@modules/storage/localStorageKeys"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export const useBoxStaffInvitationSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToBoxStaffInvitation = (args: SidebarNavigatorParams) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<BoxStaffInvitationErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxStaffInvitation />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => {
        localStorage.removeItem(LocalStorageKeys.boxStaffInvitation.boxId)
        return Promise.resolve(true)
      },
      ...args,
    })
  }

  return { navigateToBoxStaffInvitation }
}
